import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        memos: false
      },
      options: {
        memos: []
      },
      selected: {
        memo: ''
      },
      editable: {
        memo: ''
      }
    }
  },

  methods: {

    async getMemos (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.memo
      const fetching = context.fetching?.memos
      const options = context.options?.memos

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.memos = true
      context.selected.memo = ''

      const filters = {
        filter_text: search
      }

      return await SSharedList.getOpenMemos(filters).then(
        ({ data }) => {
          context.options.memos = data
        }
      ).catch(() => {
        context.options.memos = []
      }).finally(() => {
        context.fetching.memos = false
      })
    },

    async searchMemos (search, loading) {
      this.searchMemosProvider(this, search, loading)
    },

    searchMemosProvider: QUERY.debounce(
      ({ options }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.memos, {
          keys: ['memo_name', 'name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search
          }

          SSharedList.getOpenMemos(filters).then(
            ({ data }) => {
              options.memos = data
            }
          ).catch(() => {
            options.memos = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
